module.exports = __webpack_public_path__ + "4a1b2cf2ac79e2f6846970a806403121.svg";